<template>
  <el-popover
    ref="popover"
    placement="bottom-start"
    :title="title"
    :width="200"
    trigger="click"
    :visible="showOptions"
    :disabled="!hasSelection"
    @show="() => $emit('show')"
    @hide="
      () => {
        showOptions = false;
        $emit('hide');
      }
    "
  >
    <template #reference>
      <div class="level-item action" :class="{ disabled: !hasSelection }" @click="() => (showOptions = !showOptions)">
        <el-tooltip :content="$t(`components.mesh-editor.tooltip.${tooltipKey}`)" placement="bottom">
          <font-awesome-icon :icon="!showOptions ? icon : iconActive ?? icon" />
        </el-tooltip>
      </div>
    </template>
    <div v-click-outside-element="clickOutsideOptions">
      <slot></slot>
    </div>
  </el-popover>
</template>

<script lang="ts">
import { Vue, Prop, Watch, Component } from 'vue-facing-decorator';
import { ElPopover } from 'element-plus';

@Component({
  components: {},
  emits: ['show', 'hide'],
})
/* eslint-disable @typescript-eslint/no-explicit-any*/
@Component
export default class Popover extends Vue {
  @Prop() readonly title!: string;
  @Prop() readonly icon!: string;
  @Prop({ default: null }) readonly iconActive!: string | null;
  @Prop() readonly tooltipKey!: string;
  @Prop({ default: true }) readonly hasSelection!: boolean;
  showOptions = false;
  showOptionsStart = -1;

  public hide(): void {
    const popover = this.$refs.popover as typeof ElPopover;
    if (popover) popover.hide();
  }

  @Watch('showOptions', { immediate: true })
  onShowOptionsChanged(): void {
    if (this.showOptions) {
      this.showOptionsStart = Date.now();
    } else this.showOptionsStart = -1;
  }

  clickOutsideOptions(el: PointerEvent): void {
    if (this.showOptions && Date.now() - this.showOptionsStart > 1000) {
      const className = (el.target as any)?.className?.toString();
      if (!className || !className.includes('el-popover')) {
        const popover = this.$refs.popover as typeof ElPopover;
        if (popover) popover.hide();
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
